export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["अपने खाते की सभी सुविधाओं तक पहुँचने के लिए, कृपया एक त्वरित पहचान सत्यापन पूरा करें। इससे हमें आपके खाते को सुरक्षित रखने और वित्तीय नियमों का पालन करने में मदद मिलती है।"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["अभी सत्यापित करें"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["बाद में"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["अपनी पहचान सत्यापित करें"])}
}